import { render, staticRenderFns } from "./OrderDetailHeader.vue?vue&type=template&id=0c66c0be&scoped=true&"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailHeader.vue?vue&type=style&index=0&id=0c66c0be&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66c0be",
  null
  
)

export default component.exports